import type { User } from '@/store/user/types';

/**
 * Initialize UserPilot and identify user.
 * Called from Redux middleware on fetchUser.fulfilled.
 */
export function setupUserPilot(user: User) {
  const token = import.meta.env.VITE_USERPILOT_TOKEN;
  if (!token || !user) return;

  const settings = document.createElement('script');
  settings.textContent = `window.userpilotSettings = {token: "${token}"};`;
  document.head.appendChild(settings);

  const sdk = document.createElement('script');
  sdk.src = 'https://js.userpilot.io/sdk/latest.js';
  sdk.onload = () => {
    if (window.userpilot) {
      window.userpilot.identify(user.userUuid, { email: user.email });
    }
  };

  document.head.appendChild(sdk);
}
